import ButtonCinestar from 'components/Buttons/ButtonCinestar/ButtonCinestar'
import InputLayout from 'components/Inputs/InputLayout/InputLayout'
import { setErrorMessage } from 'components/Windows/CentralMessagesList/reducer'
import { useCallback, useEffect, useRef, useState } from 'react'
import ReactCrop from 'react-image-crop'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { uploadImage } from '../reducer'
import './LoadImage.scss'
import './ReactCrop.scss'

/*
 Component is based on react-image-crop library,
 The scss 'LoadImage.scss' is copied from node module to this folder, because of import issues (webpack).
*/

function setCanvasImage(image, canvas, crop) {
    if (!crop || !canvas || !image) {
        return
    }

    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')
    // refer https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio
    const pixelRatio = window.devicePixelRatio

    canvas.width = crop.width * pixelRatio * scaleX
    canvas.height = crop.height * pixelRatio * scaleY

    // refer https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setTransform
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    // refer https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/drawImage
    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY
    )
}

export default function CropImage() {
    const [crop, setCrop] = useState({
        unit: '%',
        x: 25,
        y: 25,
        width: 50,
        height: 50,
    })

    const intl = useIntl()
    const dispatch = useDispatch()
    const [upImg, setupImg] = useState(null)
    const [completedCrop, setCompletedCrop] = useState({
        unit: 'px',
        x: 25,
        y: 25,
        width: 50,
        height: 50,
    })
    const previewCanvasRef = useRef(null)
    const imgRef = useRef(null)

    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const MAX_FILE_SIZE = 5 * 1000000
            console.log()
            if (e.target.files[0].size > MAX_FILE_SIZE) {
                dispatch(setErrorMessage('TOO_BIG'))
                return console.error('It s too big.')
            }

            const reader = new FileReader()
            reader.addEventListener('load', () => {
                return setupImg(reader.result)
            })
            reader.readAsDataURL(e.target.files[0])
        }
    }

    const handleSendImage = () => {
        const cropCanvas = previewCanvasRef.current
        const base64Canvas = cropCanvas.toDataURL().split(';base64,')[1]
        dispatch(uploadImage({ blob: base64Canvas }))
        setupImg(null)
    }

    const onLoad = useCallback((e) => {
        imgRef.current = e.target
        const width = e.target.width
        const height = e.target.height
        const minDiameter = Math.min(width, height)
        const initialCrop = {
            unit: 'px',
            x: width / 4,
            y: height / 4,
            width: minDiameter / 2,
            height: minDiameter / 2,
        }
        setCompletedCrop(initialCrop)
        setCrop(initialCrop)
        setCanvasImage(imgRef.current, previewCanvasRef.current, completedCrop)
    }, [])

    useEffect(() => {
        setCanvasImage(imgRef.current, previewCanvasRef.current, completedCrop)
    }, [completedCrop])

    return (
        <>
            <InputLayout label={'Nahrát profilový obrázek'}>
                <input
                    className={'profile-image-input w-100'}
                    type="file"
                    accept="image/*"
                    onChange={onSelectFile}
                    onClick={(event) => {
                        event.target.value = null
                    }}
                />
            </InputLayout>
            <InputLayout>
                <div className={'w-100'}></div>
            </InputLayout>
            {upImg && (
                <div className="popup-bg">
                    <div className="image-preview">
                        <ReactCrop
                            circularCrop={true}
                            src={upImg}
                            crop={crop}
                            aspect={1}
                            onChange={(c) => setCrop(c)}
                            onComplete={(c) => setCompletedCrop(c)}
                        >
                            <img src={upImg} onLoad={onLoad} />
                        </ReactCrop>
                    </div>
                    <canvas
                        ref={previewCanvasRef}
                        style={{
                            display: 'none',
                            width: Math.round(completedCrop?.width ?? 0),
                            height: Math.round(completedCrop?.height ?? 0),
                        }}
                    />
                    <div className="d-flex w-25 gap-5">
                        <ButtonCinestar className={'w-100'} variant={'primary-v1'} onClick={() => setupImg()}>
                            Zrušit
                        </ButtonCinestar>
                        <ButtonCinestar className={'w-100'} variant={'primary-v1'} onClick={() => handleSendImage()}>
                            {intl.formatMessage({ id: 'buttons.add' })}{' '}
                        </ButtonCinestar>
                    </div>
                </div>
            )}
        </>
    )
}
